import * as React from "react"
import { Container } from "react-bootstrap" 
import { StaticImage } from "gatsby-plugin-image"
import { Grid } from '@mantine/core';



const image = "https://images.unsplash.com/photo-1618219944342-824e40a13285?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1854&q=80"
const altText = "Some cool stuff"
const packageName = "Massages"



function OptionsGallery() {
	return (

    <div className="spa-options">
        <Container>
				<Grid>


                    <Grid.Col span={6}>
                        <div className="image">
                            <StaticImage src={image} quality={60}formats={["auto", "webp", "avif"]} placeholder="blurred" alt={altText}/>
                            <div className="absolute">
                                <h3><strong>{packageName}</strong></h3>
                            </div>
                        </div>                        
                    </Grid.Col>

                    <Grid.Col span={6}>
                        <div className="image">
                            <StaticImage src={image} quality={60}formats={["auto", "webp", "avif"]} placeholder="blurred" alt={altText}/>
                            <div className="absolute">
                                <h3><strong>{packageName}</strong></h3>
                            </div>
                        </div>                        
                    </Grid.Col>

                    <Grid.Col span={6}>
                        <div className="image">
                            <StaticImage src={image} quality={60}formats={["auto", "webp", "avif"]} placeholder="blurred" alt={altText}/>
                            <div className="absolute">
                                <h3><strong>{packageName}</strong></h3>
                            </div>
                        </div>                        
                    </Grid.Col>

                    <Grid.Col span={6}>
                        <div className="image">
                            <StaticImage src={image} quality={60}formats={["auto", "webp", "avif"]} placeholder="blurred" alt={altText}/>
                            <div className="absolute">
                                <h3><strong>{packageName}</strong></h3>
                            </div>
                        </div>                        
                    </Grid.Col>

                    <Grid.Col span={6}>
                        <div className="image">
                            <StaticImage src={image} quality={60}formats={["auto", "webp", "avif"]} placeholder="blurred" alt={altText}/>
                            <div className="absolute">
                                <h3><strong>{packageName}</strong></h3>
                            </div>
                        </div>                        
                    </Grid.Col>

                    <Grid.Col span={6}>
                        <div className="image">
                            <StaticImage src={image} quality={60}formats={["auto", "webp", "avif"]} placeholder="blurred" alt={altText}/>
                            <div className="absolute">
                                <h3><strong>{packageName}</strong></h3>
                            </div>
                        </div>                        
                    </Grid.Col>

                    

                    </Grid>
			</Container>
	</div>

    );
}

export default OptionsGallery;